import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'

import CreditCardIcon from 'client/icons/CreditCard'

import { ConfirmationContainer, ConfirmationTitle } from './styles'

const PaymentConfirmationLoader = ({ title, message }) => {
  return (
    <ConfirmationContainer data-testid="waiting-for-confirmation-message">
      <CreditCardIcon size={72} />
      <ConfirmationTitle>
        <FormattedMessage {...title} />
      </ConfirmationTitle>
      <FormattedMessage {...message} />
    </ConfirmationContainer>
  )
}

PaymentConfirmationLoader.propTypes = {
  title: PropTypes.shape({
    id: PropTypes.string.isRequired,
    defaultMessage: PropTypes.string,
  }).isRequired,
  message: PropTypes.shape({
    id: PropTypes.string.isRequired,
    defaultMessage: PropTypes.string,
  }).isRequired,
}

export default PaymentConfirmationLoader
